"use strict";

var _toConsumableArray = require("/home/runner/work/web/web/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _regeneratorRuntime = require("/home/runner/work/web/web/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/home/runner/work/web/web/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/web/web/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SchedulableTask_1 = require("./SchedulableTask");

var SchedulerError_1 = __importDefault(require("./SchedulerError"));

var SchedulerMutexStrategy_1 = require("./SchedulerMutexStrategy");

var Builder_1 = __importDefault(require("./Builder"));

var ExecutionState;

(function (ExecutionState) {
  ExecutionState[ExecutionState["PENDING"] = 0] = "PENDING";
  ExecutionState[ExecutionState["EXECUTING"] = 1] = "EXECUTING";
  ExecutionState[ExecutionState["TERMINATED"] = 2] = "TERMINATED";
})(ExecutionState || (ExecutionState = {}));

function rejectTask(task, error) {
  var _iterator = _createForOfIteratorHelper(task.listeners),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var listener = _step.value;
      listener.reject(error);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

var Scheduler = /*#__PURE__*/function () {
  function Scheduler(maxConcurrentTasks) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Scheduler);

    this._queue = [];
    this._isExecuting = false;
    this._idleListeners = [];
    this._maxConcurrentTasks = maxConcurrentTasks;
    this._samePriorityMutex = !!options.samePriorityMutex;
    this._mutexStrategy = options.mutexStrategy || SchedulerMutexStrategy_1.mutexEquality;

    if (options.disableLogging) {
      this._errorLog = function () {};
    } else {
      this._errorLog = console.error;
    }
  }

  _createClass(Scheduler, [{
    key: "enqueue",
    value: function enqueue(task) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (typeof task === 'function') {
          task = {
            priority: 0,
            execute: task
          };
        }

        var mutexResult = _this._checkMutexes(task, resolve, reject);

        if (mutexResult.task) {
          _this._addTask(mutexResult.task);
        } else if (mutexResult.canceled) {
          reject(_this.createCanceledError());
        }
      });
    }
  }, {
    key: "prepare",
    value: function prepare(task) {
      return new Builder_1.default(task, this);
    }
  }, {
    key: "_addTask",
    value: function _addTask(task) {
      this._queue.push(task);

      this._applyPriorities();

      if (!this._isExecuting) {
        this._isExecuting = true; // Queue will be executed on next tick

        setTimeout(this._executeNextTasks.bind(this));
      }
    }
  }, {
    key: "executingTasks",
    get: function get() {
      return this._queue.reduce(function (count, task) {
        return task.state === ExecutionState.EXECUTING ? count + 1 : count;
      }, 0);
    }
  }, {
    key: "createCanceledError",
    value: function createCanceledError() {
      return new SchedulerError_1.default(50, "Task has been canceled in favor of another task");
    }
  }, {
    key: "_findFirstPendingTask",
    value: function _findFirstPendingTask() {
      return this._queue.find(function (task) {
        return task.state === ExecutionState.PENDING;
      });
    }
  }, {
    key: "_isIdle",
    value: function _isIdle() {
      return this._queue.length === 0 || !this._queue.find(function (task) {
        return task.state !== ExecutionState.TERMINATED;
      });
    }
  }, {
    key: "_removeTaskAt",
    value: function _removeTaskAt(index) {
      this._queue.splice(index, 1);
    }
  }, {
    key: "_executeTask",
    value: function _executeTask(task) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var index;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (task.task.onPreExecute) {
                  task.task.onPreExecute();
                }

                _context.next = 4;
                return task.task.execute();

              case 4:
                return _context.abrupt("return", _context.sent);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                throw _context.t0;

              case 10:
                _context.prev = 10;
                task.state = ExecutionState.TERMINATED;
                index = this._queue.indexOf(task);

                this._removeTaskAt(index);

                this._executeNextTasks();

                return _context.finish(10);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7, 10, 16]]);
      }));
    }
  }, {
    key: "_executeNextTasks",
    value: function _executeNextTasks() {
      var _this2 = this;

      var executing = this.executingTasks;

      if (executing >= this._maxConcurrentTasks) {
        return;
      }

      var launchable = this._maxConcurrentTasks - executing;

      var _loop = function _loop(i) {
        var task = _this2._findFirstPendingTask();

        if (!task) {
          if (_this2._isIdle()) {
            _this2._switchToIdle();
          }

          return {
            v: void 0
          };
        }

        task.state = ExecutionState.EXECUTING;

        _this2._executeTask(task).then(function (result) {
          var _iterator2 = _createForOfIteratorHelper(task.listeners),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var resolve = _step2.value.resolve;

              try {
                resolve(result);
              } catch (e) {
                _this2._errorLog('An error occurred while resolving listener', e);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }).catch(function (error) {
          var _iterator3 = _createForOfIteratorHelper(task.listeners),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var reject = _step3.value.reject;

              try {
                reject(error);
              } catch (e) {
                _this2._errorLog('An error occurred while rejecting listener', e);
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        });
      };

      for (var i = 0; i < launchable; i++) {
        var _ret = _loop(i);

        if (typeof _ret === "object") return _ret.v;
      }
    }
  }, {
    key: "_switchToIdle",
    value: function _switchToIdle() {
      this._isExecuting = false;
      var idleListeners = this._idleListeners;
      this._idleListeners = [];

      var _iterator4 = _createForOfIteratorHelper(idleListeners),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var resolve = _step4.value.resolve;

          try {
            resolve();
          } catch (e) {}
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "waitForIdle",
    value: function waitForIdle() {
      var _this3 = this;

      if (!this._isExecuting) {
        return Promise.resolve();
      }

      return new Promise(function (resolve, reject) {
        _this3._idleListeners.push({
          resolve: resolve,
          reject: reject
        });
      });
    }
  }, {
    key: "_applyPriorities",
    value: function _applyPriorities() {
      this._queue.sort(function (a, b) {
        return b.task.priority - a.task.priority;
      });
    }
  }, {
    key: "_checkMutexes",
    value: function _checkMutexes(newTask, resolve, reject) {
      for (var i = 0; i < this._queue.length; i++) {
        var taskA = this._queue[i];

        if (taskA.state === ExecutionState.TERMINATED) {
          // Terminated tasks will be ignored
          continue;
        }

        if (this._samePriorityMutex && taskA.task.priority != newTask.priority) {
          // Skip check if not the same priority
          continue;
        }

        if (!taskA.task.mutex || !newTask.mutex || !this._mutexStrategy(taskA.task.mutex, newTask.mutex)) {
          // If mutexes do not collide, skip check
          continue;
        }

        var strategyA = void 0;
        var strategyB = void 0;

        if (taskA.task.onTaskCollision) {
          strategyA = taskA.task.onTaskCollision(newTask);

          if (strategyA === SchedulableTask_1.TaskCollisionStrategy.KEEP_OTHER && taskA.state !== ExecutionState.EXECUTING) {
            this._removeTaskAt(i--);

            rejectTask(taskA, this.createCanceledError());
            continue;
          } else if (strategyA === SchedulableTask_1.TaskCollisionStrategy.KEEP_THIS) {
            return {
              canceled: true
            };
          } else if (strategyA === SchedulableTask_1.TaskCollisionStrategy.RESOLVE_OTHER) {
            this._removeTaskAt(i--);

            return {
              canceled: false,
              task: {
                task: newTask,
                state: ExecutionState.PENDING,
                listeners: [{
                  resolve: resolve,
                  reject: reject
                }].concat(_toConsumableArray(taskA.listeners))
              }
            };
          } else if (strategyA === SchedulableTask_1.TaskCollisionStrategy.RESOLVE_THIS) {
            taskA.listeners = [].concat(_toConsumableArray(taskA.listeners), [{
              resolve: resolve,
              reject: reject
            }]);
            return {
              canceled: false
            };
          }
        }

        if (newTask.onTaskCollision) {
          strategyB = newTask.onTaskCollision(taskA.task);

          if (strategyB === SchedulableTask_1.TaskCollisionStrategy.KEEP_OTHER) {
            return {
              canceled: true
            };
          } else if (strategyB === SchedulableTask_1.TaskCollisionStrategy.KEEP_THIS) {
            this._removeTaskAt(i--);

            rejectTask(taskA, this.createCanceledError());
            continue;
          } else if (strategyB === SchedulableTask_1.TaskCollisionStrategy.RESOLVE_OTHER) {
            taskA.listeners = [].concat(_toConsumableArray(taskA.listeners), [{
              resolve: resolve,
              reject: reject
            }]);
            return {
              canceled: false
            };
          } else if (strategyB === SchedulableTask_1.TaskCollisionStrategy.RESOLVE_THIS) {
            this._removeTaskAt(i--);

            return {
              canceled: false,
              task: {
                task: newTask,
                state: ExecutionState.PENDING,
                listeners: [{
                  resolve: resolve,
                  reject: reject
                }].concat(_toConsumableArray(taskA.listeners))
              }
            };
          }
        }

        if (strategyA === SchedulableTask_1.TaskCollisionStrategy.KEEP_BOTH && strategyB === SchedulableTask_1.TaskCollisionStrategy.KEEP_BOTH) {
          // Both tasks chose to ignore the collision, so both tasks will be kept
          continue;
        } // Apply default action by keeping the already existing task and rejecting the new one


        return {
          canceled: true
        };
      }

      return {
        canceled: false,
        task: {
          task: newTask,
          state: ExecutionState.PENDING,
          listeners: [{
            resolve: resolve,
            reject: reject
          }]
        }
      };
    }
  }]);

  return Scheduler;
}();

exports.default = Scheduler;